import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { PermissionRoute } from '@/features/auth';
import { FULL_WIDTH_PAGE } from '@/shared/layouts/pageLayout';
import { DealerCreate } from '../pages/DealerCreate';
import { DealerDetail } from '../pages/DealerDetail';
import { DealerEdit } from '../pages/DealerEdit';
import { DealerList } from '../pages/DealerList';
import { FundAccountStatementPage } from '../pages/FundAccountStatementPage';
import { DealerConfigOptionList } from '../pages/DealerConfigOptionList';
import { DealerConfigOptionDetail } from '../pages/DealerConfigOptionDetail';

export const dealersRoutes: RouteObject[] = [
  {
    path: 'admin/dealers',
    children: [
      {
        element: <PermissionRoute requiredPermissions={[{ resource: 'dealer', action: 'browse' }]} />,
        children: [
          { index: true, element: <DealerList /> },
        ],
      },
      {
        element: <PermissionRoute requiredPermissions={[{ resource: 'dealer', action: 'add' }]} />,
        children: [
          { path: 'new', element: <DealerCreate /> },
        ],
      },
      {
        // Legacy `/admin/dealers/search` URL: keep an explicit static segment so
        // bookmarks don't fall through to `:id` and trigger a `/dealers/search`
        // lookup that renders a 404 in DealerDetail.
        path: 'search',
        element: <Navigate to="/admin/dealers" replace />,
      },
      {
        // Config-options CATALOG (Epic 7.1.4 P4a). Declared as explicit static
        // segments — mirroring the `search` guard above — BEFORE the `:id`
        // catch, so `/admin/dealers/config-options[...]` resolves to the
        // catalog pages rather than falling through to DealerDetail's
        // `/dealers/config-options` lookup.
        element: <PermissionRoute requiredPermissions={[{ resource: 'dealer', action: 'config-option.browse' }]} />,
        children: [
          { path: 'config-options', element: <DealerConfigOptionList /> },
        ],
      },
      {
        element: <PermissionRoute requiredPermissions={[{ resource: 'dealer', action: 'config-option.read' }]} />,
        children: [
          { path: 'config-options/:optionId', element: <DealerConfigOptionDetail /> },
        ],
      },
      {
        path: ':id',
        element: <DealerDetail />,
        handle: FULL_WIDTH_PAGE,
      },
      {
        path: ':id/fund-accounts/:sellingDealerId/:productId/statement',
        element: <FundAccountStatementPage />,
      },
      {
        path: ':id/edit',
        element: <DealerEdit />,
      },
    ],
  },
];
